import React, {Component} from 'react';
import {AJAX, get_phone_id, getCookie, setCookie} from "./functions";
import {Link} from "react-router-dom";
import Toggle from 'react-toggle';
import Popup from "./popups/Popup";
import Avatar from "./common/Avatar";
import 'react-toggle/style.css';

class Menu extends Component {
    state = {
        soundChecked: true,
        notificationChecked: true,
        marketingChecked: true,
        displaySideBar: false
    };
    home_url = window.bm_url;

    constructor(props) {
        super(props);

        let bulk_notify = getCookie('bm_bulk_notify');
        if (bulk_notify === null) {
            setCookie('bm_bulk_notify', 1)
        } else {
            this.state.notificationChecked = bulk_notify == 1 ? true : false;
        }

        this.abstractClick = this.abstractClick.bind(this);
        this.toggleSideBar = this.toggleSideBar.bind(this);
        this.handleChangeSwitch = this.handleChangeSwitch.bind(this);
        this.clickOnLink = this.clickOnLink.bind(this);
        this.getProfile = this.getProfile.bind(this);
        this.getLinksOfMenu = this.getLinksOfMenu.bind(this);
        this.logout = this.logout.bind(this);
    }

    componentDidMount() {
        this.getProfile();
    }

    componentDidUpdate(prevState) {
        if (prevState.displaySideBar !== this.state.displaySideBar) {
            let el = document.querySelector('.all-content');
            if (this.state.displaySideBar)
                el.classList.add('open-sidebar');
            else
                el.classList.remove('open-sidebar');
        }
    }

    abstractClick = () => {
    };

    clickOnLink(event) {
        this.toggleSideBar();
        showPreloader();
        // let targ = event.target;
        // event.preventDefault();
        // this.st_id = setTimeout(()=>(window.location.href = targ.href),250);
    }

    toggleSideBar() {
        this.setState({displaySideBar: !this.state.displaySideBar});
    }

    handleChangeSwitch = (key, val) => {
        if (key === 'notificationChecked') {
            let t = this;
            let b_n = val ? 1 : 0;
            setCookie('bm_bulk_notify', b_n)
            let params = {
                action: 'api/booking/update_bulk_notify',
                bulk_notify: b_n
            };
            AJAX(bm_ajax_url, 'POST', params, {
                response_json: true,
                func_callback: function (resp) {console.log(resp)},
            });
        }
        this.setState({[key]:val});
    };

    componentWillUnmount() {
        if (this.st_id !== undefined)
            clearTimeout(this.st_id);
    }

    getProfile() {
        let t = this;
        let params = {
            action: 'api/booking/get_profile'
        };
        AJAX(bm_ajax_url, 'POST', params, {
            response_json: true,
            func_callback: function (resp) {
                if (resp.success === 1 && Object.keys(resp.data).length && resp.data.client_data) {
                    window.gClientData = resp.data.client_data;
                    if (typeof window.forceUpdateWelcomePage === 'function') window.forceUpdateWelcomePage();
                    get_phone_id();
                }

            },
        });
    }

    getLinksOfMenu() {
        let home_url = this.home_url+'/welcome/';
        let links = {
            home:  <a href={home_url} onClick={(event => this.clickOnLink(event))}>Home</a>,
            logout: <a href={home_url} onClick={this.logout}>Logout</a>,
            website: <a href="//gowiththegecko.com.au" target="_blank">Go With The Gecko Website</a>

        };
        let menuTitles = {
            profile: 'Profile',
            terms: 'Terms and Conditions',
            hire_info: 'Hire Information'
        };
        if (this.props.notUseReact) {
            links.profile = <a href={this.home_url+"/profile/"} onClick={this.clickOnLink}>{menuTitles.profile}</a>;
            links.terms = <a href={this.home_url+"/terms_and_conditions/"} onClick={this.clickOnLink}>{menuTitles.terms}</a>;
            links.hire_info = <a href={this.home_url+"/hire_information/"} onClick={this.clickOnLink}>{menuTitles.hire_info}</a>;
        } else {
            links.profile = <Link to="/profile" onClick={this.toggleSideBar}>{menuTitles.profile}</Link>;
            links.terms = <Link to="/terms_and_conditions/" onClick={this.toggleSideBar}>{menuTitles.terms}</Link>;
            links.hire_info = <Link to="/hire_information/" onClick={this.toggleSideBar}>{menuTitles.hire_info}</Link>;
        }
        return links;
    }

    logout(e) {
        e.preventDefault();
        let link = e.target.href;
        showPreloader();
        AJAX(bm_ajax_url, 'POST', {action: 'api/booking/logout'}, {
            response_json: true,
            func_callback: function (resp) {
                if (resp.success === 1) {
                    window.location.href = link;
                }
            },
        });
    }

    render() {
        let menu  = this.getLinksOfMenu();
        return (
            <>
                <input type="checkbox" id="nav-toggle" checked={this.state.displaySideBar} onChange={this.toggleSideBar} hidden/>
                <label htmlFor="nav-toggle" className="nav-toggle" onClick={this.abstractClick}>
                    <div/>
                    <div/>
                    <div/>
                </label>
                <nav className="nav nav-sidebar">
                    <Avatar globalFuncName={'updateAvatarInMenu'} />
                    <div className="title">{window.gClientData.first_name || ''}</div>
                    <div className="subtitle">{window.gClientData.last_name || ''}</div>
                    <ul>
                        <li>{menu.home}</li>
                        <li>{menu.profile}</li>
                        <li>{menu.terms}</li>
                        <li>{menu.hire_info}</li>
                        <li>{menu.website}</li>
                        <li>
                            <label htmlFor="notification-switch">
                                <span>Notifications</span>
                                <Toggle
                                    id="notification-switch"
                                    checked={this.state.notificationChecked}
                                    onChange={(e) => this.handleChangeSwitch('notificationChecked', e.target.checked)}
                                    icons={false}
                                    aria-label="Notifications toggle"
                                />

                            </label>
                            <Popup
                                trigger={<div className="info-icon info-icon-sidebar" />}
                                position="left center"
                                on="hover"
                            >
                                <Card text="For stopping and starting the alerts from notifications within the Book 'N Go App." />
                            </Popup>
                        </li>
                        <li>
                            <label htmlFor="marketing-switch">
                                <span>Marketing Opt</span>
                                <Toggle
                                    id="marketing-switch"
                                    checked={this.state.marketingChecked}
                                    onChange={(val)=>this.handleChangeSwitch('marketingChecked',val)}
                                    icons={false}
                                    aria-label="Marketing toggle"
                                />
                            </label>
                            <Popup
                                trigger={<div className="info-icon info-icon-sidebar" />}
                                position="left center"
                                on="hover"
                            >
                                <Card text="For stopping and starting marketing messages produced by Go With The Gecko within the Book 'N Go App." />
                            </Popup>
                        </li>
                        <li>
                            <a href="tel:0296154426">CALL ROADSIDE ASSISTANCE</a>
                        </li>
                        {
                            window.gClientData.email ? (
                                <li>{menu.logout}</li>
                            ) : null
                        }
                    </ul>
                </nav>
            </>
        );
    }
}

export default Menu;

const Card = ({ title, text }) => {
    return (
    <div className="card">
        {
            title ? (<>
                <div className="header">{title}</div>
                <hr/>
            </>) : ('')
        }
        <div className="content">
            {text}
        </div>
    </div>
)};
